import { IDS } from "./pnp-docs.constants";


export const dashboardState = {
    name: IDS.app_policies_documents_dashboard,
    url: '',
    component: 'dashboard',
};
